"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var script_1 = __importDefault(require("./script"));
var Video = /** @class */ (function (_super) {
    __extends(Video, _super);
    function Video(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            interaction: false,
        };
        return _this;
    }
    Video.prototype.initializeSvpPlayer = function () {
        var _this = this;
        var _a = this.props, id = _a.id, native = _a.native;
        if (native.video) {
            var content = native.video.content;
            var videoPoster = native.image ? native.image.url : '';
            if (content) {
                var trimmedContent = content.replace(new RegExp('<ClickThrough[\\d\\D]*?/ClickThrough>', 'g'), '');
                var blobURL = URL.createObjectURL(new Blob([trimmedContent], {
                    type: 'text/xml',
                }));
                try {
                    if ('SVP' in window) {
                        var svp_1 = new SVP.Player({
                            id: id,
                            vendor: 'appnexus',
                            node: 'ad-player-' + id,
                            autoplay: false,
                            mute: true,
                            skin: {
                                name: 'vgtv',
                            },
                            poster: videoPoster,
                            settings: {
                                jw: {
                                    abouttext: 'Annonse',
                                    advertising: {
                                        client: 'vast',
                                        tag: blobURL,
                                    },
                                },
                            },
                        });
                        svp_1.on('adPause', function (data) {
                            if (data.pauseReason === 'interaction') {
                                _this.setState({ interaction: true });
                            }
                        });
                        svp_1.on('ready', function () {
                            var player = svp_1.model.player;
                            player.on('viewable', function (isVisible) {
                                if (!_this.state.interaction) {
                                    if (isVisible.viewable) {
                                        player.play();
                                    }
                                    else {
                                        player.pause();
                                    }
                                }
                            });
                        });
                    }
                }
                catch (ex) {
                    console.error(ex);
                }
            }
        }
    };
    Video.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('onSvpPlayerReady', function () {
            _this.initializeSvpPlayer();
        });
    };
    Video.prototype.render = function () {
        var _this = this;
        var id = this.props.id;
        return (React.createElement("div", { style: {
                position: 'relative',
                width: '100%',
                height: '0',
                paddingTop: '56.25%',
            } },
            React.createElement("div", { style: {
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                } },
                React.createElement("div", { id: 'ad-player-' + id })),
            React.createElement(script_1.default, { src: "https://cdn.stream.schibsted.media/player/3.26.1/player.min.js", initializeSvpPlayer: function () { return _this.initializeSvpPlayer(); } })));
    };
    return Video;
}(React.Component));
exports.default = Video;
